import { TipoUbicacion, Ubicacion } from "src/app/shared/model/asistencia/asistencia.model";

/** El catalogo de sitios; el editor regresa aqui. */
export const RUTA_SITIOS = "/asistencia/ubicaciones";

/** Los filtros del catalogo: viajan al editor y de regreso para no perderlos. */
export interface FiltrosSitios {
  nombre: string;
  tipo: TipoUbicacion;
  estatus: string;
}

/** Lo que el catalogo deja en history.state al abrir el editor. */
export interface EstadoEditorSitio {
  ubicacion?: Ubicacion;
  filtros?: FiltrosSitios;
}
